import { FC, ButtonHTMLAttributes } from 'react'
import { Button } from '@/root/ui/shared/Button/Button'
import Loader from '@/root/ui/shared/Loader/Loader'
import { TrashBinIcon } from '@/root/ui/shared/icons/TrashBinIcon'

interface DeleteTicketButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string
  loading?: boolean
}

export const DeleteTicketButton: FC<DeleteTicketButtonProps> = ({ title, loading, ...props }) => {
  return (
    <Button
      type="button"
      variant="contained"
      className="bg-error-medium-light! disabled:opacity-50 w-full pt-3 pb-3 text-base"
      disabled={loading}
      {...props}
    >
      <div className="flex items-center justify-center gap-2">
        {loading ? <Loader className="size-4" /> : <TrashBinIcon color="white" width={16} />}
        <div>{title}</div>
      </div>
    </Button>
  )
}
